<template>
  <div>
    <v-card>
      <v-card-text>
        <v-form ref="ProductForm" v-model="ProductValid">
          <v-row>
            <v-col cols="12" sm="6" md="4" v-if="categoryType == 'Product'">
              <div dir="rtl">
                <label>نوع محصول *</label>
                <v-select
                  v-model="product.productType"
                  outlined
                  placeholder="انتخاب نوع محصول"
                  dense
                  :items="productTypeItems"
                  item-value="title"
                  item-text="displayName"
                />
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn @click="beforeStep()" color="secondery">
            بازگشت به مرحله قبل
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const enumsRepository = RepoFactory.get('enums');
import Helper from '@/core/helpers';
export default {
  props: {
    categoryType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      ProductValid: true,
      product: {},
      productTypeItems: [],
      supplyTypeItems: [],
    };
  },
  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
  },
  created() {
    this.productType();
    this.supplyType();
    if (this.$store.getters.supplierProductSelectedForEdit) {
      this.product.productType =
        this.$store.getters.supplierProductSelectedForEdit.productType;
    }
  },
  methods: {
    beforeStep() {
      this.$emit('goToImageStep');
    },
    supplyType() {
      const loader = this.$loading.show();
      enumsRepository
        .getEnum('SupplyTypeItems', this.productBaseUrl)
        .then((res) => {
          this.supplyTypeItems = res.data;
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    productType() {
      const loader = this.$loading.show();
      enumsRepository
        .getEnum('ProductTypeItems', this.productBaseUrl)
        .then((res) => {
          this.productTypeItems = res.data;
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
